import * as yup from 'yup';
import { GetSchemaOptions } from '../types';
import { 
  getFieldsSchema,
  getAvgFixedPopulationInputSchema,
  getSeedCostInputSchema,
  getTargetYieldInputSchema 
} from './fields';
import { getGlobalInputsSchema } from './global-inputs';

export const getSharedSchema = (step: number, options: GetSchemaOptions) => {
  const { productValidationValues } = options;
  const validateStep2 = step === 2 && !!productValidationValues;

  return yup.object({
    ...getFieldsSchema(validateStep2, options),
    ...getGlobalInputsSchema(validateStep2, options),
  });
};

export const getDraftSchema = (options: GetSchemaOptions) => {
  const { productValidationValues, currency } = options;
  return yup.object({
    avgFixedPopulation: getAvgFixedPopulationInputSchema({ productValidationValues, currency }),
    seedCostPerBag: getSeedCostInputSchema({ productValidationValues, currency }),
    targetYield: getTargetYieldInputSchema({ productValidationValues, currency })
  });
};